import { ContactActionDialog } from 'components/lenders/ContactActionDialog';
import React, { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  activateClientUserAuthAccountSlice,
  patchActivateClientUserAsyncAction,
} from 'store/order/clientLenderContacts/clientUserAuthAccountSlice';
import { useAppDispatch } from 'store/store';
import { RootStore } from 'store/types';
import { IPresentationClientUserData } from 'types/clients/IClientUser';
import { eClientContactActionType } from 'types/contacts/eClientContactActionType';
import { ClientUsersAPI } from 'API/clients/ClientUsersApi';
import { eAPITags } from 'API/eAPITags';

export interface IActivateClientUserProps {
  done: () => void;
  user: IPresentationClientUserData;
  clientCompanyId: string;
}

export const ActivateClientUser: React.FC<IActivateClientUserProps> = ({ done, user, clientCompanyId }) => {
  const dispatch = useAppDispatch();
  const onReset = useCallback(() => dispatch(activateClientUserAuthAccountSlice.actions.reset({})), [dispatch]);
  useEffect(() => {
    onReset();
  }, [onReset]);
  const activate = async () => {
    await dispatch(patchActivateClientUserAsyncAction({ clientCompanyId, clientUserId: user.id }));
    dispatch(ClientUsersAPI.util.invalidateTags([{ type: eAPITags.ClientUsers, id: clientCompanyId }]));
  };
  const { fetchStatus, fetchError } = useSelector(
    (store: RootStore) => store.clientLenderContacts.activateClientUserAuthAccountSlice
  );
  return (
    <ContactActionDialog
      onDone={done}
      onReset={onReset}
      onAction={activate}
      fetchStatus={fetchStatus}
      fetchError={fetchError}
      email={user.email}
      name={`${user.firstName} ${user.lastName}`}
      actionType={eClientContactActionType.Activate}
    />
  );
};
